/* @ngInject */
const myActionButtons = () => {
  return {
    restrict: 'E',
    scope: {
      myData: '=',
      myNature: '=',
    },
    template: require('./myActionButtons.html'),

    /* @ngInject */
    controller: ($scope, entities) => {
      $scope.buttons = entities[$scope.myNature].metadata.buttons
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => { },
    },
  }
}

export default myActionButtons



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/buttons/myActionButtons.js